import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { hasPersons } from '../../../core/states/offer/offer.selector';
import { map } from 'rxjs/operators';

export const personsRegisteredGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const router: Router = inject(Router);
  const store: Store = inject(Store);

  return store.select(hasPersons).pipe(map((hasPersonsInStore) => hasPersonsInStore || router.parseUrl('/')));
};
